var camelizeRE = /-(\w)/g;
export function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c.toUpperCase();
  });
}
export function padZero(num) {
  return (num < 10 ? '0' : '') + num;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.0.5@vant/es/utils/format/string.js
// module id = pHez
// module chunks = 0